// extracted by mini-css-extract-plugin
module.exports = {"links":"index-module--links--15Ez_","link":"index-module--link--3xZyZ"};